import { handleActions } from 'redux-actions';
import * as base from 'store/BaseReducers';

import * as actions from './actions';


const initialState = Object.assign({},
  base.ListState,
  base.DetailState,
  base.EditState,
);

export default handleActions(
  {
    [actions.articleShowEditForm]: (state, action) => base.showEditForm(state, action),

    [actions.articleListLoadRequest]: (state, action) => base.listLoadRequest(state, action),
    [actions.articleListLoadComplete]: (state, action) => base.listLoadComplete(state, action),
    [actions.articleListLoadError]: (state, action) => base.listLoadError(state, action),

    [actions.articleDetailLoadRequest]: (state, action) => base.detailLoadRequest(state, action),
    [actions.articleDetailLoadComplete]: (state, action) => base.detailLoadComplete(state, action),
    [actions.articleDetailLoadError]: (state, action) => base.detailLoadError(state, action),

    [actions.articleUpdateRequest]: (state, action) => base.updateRequest(state, action),
    [actions.articleUpdateComplete]: (state, action) => base.updateComplete(state, action),
    [actions.articleUpdateError]: (state, action) => base.updateError(state, action),

    [actions.articleDeleteRequest]: (state, action) => base.deleteRequest(state, action),
    [actions.articleDeleteComplete]: (state, action) => base.deleteComplete(state, action),
    [actions.articleDeleteError]: (state, action) => base.deleteError(state, action),
  },
  initialState
);
